import gql from 'graphql-tag';

export const createNodeQuery = gql`mutation createFolder($nodeName: String!, $createdBy: String!,
    $nodeLifecyclePolicy: String!,
    $nodeDatalakePath: String!, $markForDeletion: Boolean, $createdOn: Date, $nodeDir: String ) {
    createSysDataOrg(
        input: {
            sysDataOrg: {
                nodeName: $nodeName,
                nodeLifecyclePolicy: $nodeLifecyclePolicy,
                nodeDatalakePath: $nodeDatalakePath,
                createdBy: $createdBy,
                createdOn: $createdOn,
                markForDeletion: $markForDeletion,
                nodeDir: $nodeDir
            }
        }
    ) {
        sysDataOrg {
            dataOrgNodeId
        }
    }
  }
  ` ;
export const readFilesQuery = gql`query readDataOrgFilebyDataOrgNodeId ($dataOrgNodeId: UUID!) {
    sysDataOrgFiles(condition: {dataOrgNodeId: $dataOrgNodeId}) {
      nodes {
        createdBy
        updatedBy
        createdOn
        updatedOn
        dataOrgNodeId
        dataOrgFileId
        fileName
        fileVersion
        fileSize
        markForDeletion
        dataOrgNode {
          nodeLifecyclePolicy
        }
      }
    }
  }
`;
export const readPolicyQuery = gql`query readPolicyByDataOrgNodeId ($dataOrgNodeId: UUID!) {
    sysPolicies(condition: {dataOrgNodeId: $dataOrgNodeId}) {
      nodes {
        policyDesc
        createdBy
        updatedBy
        createdOn
        updatedOn
        applyForChildNodes
        markForDeletion
        dataOrgNodeId
        policyTypeLookupId,
        policyName
      }
    }
  }
`;
export const updateFolderPolicy = gql`mutation updateFolderPolicy ($dataOrgNodeId: UUID!, $nodeLifecyclePolicy: String,
    $updatedBy: String, $updatedOn: Date) {
        updateSysDataOrg(input: {patch: {nodeLifecyclePolicy: $nodeLifecyclePolicy,
            updatedBy: $updatedBy, updatedOn: $updatedOn}, dataOrgNodeId: $dataOrgNodeId}) {
        clientMutationId
    }
}`;
export const updateFilePolicy = gql`mutation updateFilePolicy ($dataOrgFileId: UUID!, $nodeLifecyclePolicy: String,
    $updatedBy: String, $updatedOn: Date) {
        updateSysDataOrgFile(input: {patch: {nodeLifecyclePolicy: $nodeLifecyclePolicy,
            updatedBy: $updatedBy, updatedOn: $updatedOn}, dataOrgFileId: $dataOrgFileId}) {
        clientMutationId
    }
}`;
export const readGroupsOnUserId = gql`query getGroupsOnUserId($userId: UUID!, $markForDeletion: Boolean) {
  sysUserGroupMappings(condition: {userId: $userId, markForDeletion: $markForDeletion}) {
      nodes {
        groupId
      }
  }
}`;
export const readPoliciesOnDataOrgId = gql`query getPoliciesOndataOrgId($dataOrgNodeId: UUID!, $markForDeletion: Boolean) {
  sysPolicies(filter: {dataOrgFileId: {isNull: true}, dataOrgNodeId: {equalTo: $dataOrgNodeId},
      markForDeletion: {equalTo: $markForDeletion}}) {
  nodes {
    applyForChildNodes
    policyId
    sysPolicyUserGroupMappingsByPolicyId {
      nodes {
        groupId
        privileges
      }
    }
  }
}
}`;
export class FolderDetails {
    nodeName: string;
    nodeLifecyclePolicy: string;
    nodeDatalakePath: string;
    createdBy: string;
    createdOn: Date;
    markForDeletion: boolean;
    nodeDir: string;
}
export class FileInfo {
    createdBy: string;
    updatedBy: string;
    createdOn: Date;
    updatedOn: Date;
    dataOrgNodeId: string;
    fileName: string;
    fileVersion: string;
    fileSize: string;
    markForDeletion: boolean;
    dataOrgNode: object;
}
export class FolderInfo {
    created_by: string;
    updated_by: string;
    created_on: Date;
    updated_on: Date;
    data_org_node_id: string;
    node_name: string;
    mark_for_deletion: boolean;
    node_lifecycle_policy: string;
    node_dir: string;
}
